import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.sass'],
})
export class ButtonComponent implements OnChanges {
  @Input() theme = '';
  @Input() label = 'Button';
  @Input() buttonDisabled = false;
  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['buttonDisabled'] && !changes['buttonDisabled'].currentValue) {
      this.buttonDisabled = changes['buttonDisabled'].currentValue;
    }
  }
}
